import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import { badgesList } from "../apiConfigs";

export const getBadgesListApi = createAsyncThunk(
    "auth/crowns-and-badges/getBadgesList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(badgesList);
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);
const intialState = { result: [], loading: false, error: null, message: "" };
const getBadgesListSlice = createSlice({
    name: "auth/crowns-and-badges/getBadgesList",
    initialState: { result: [], loading: false, error: null, message: "" },
    reducers: {
        resetgetBadgesList: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(getBadgesListApi.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getBadgesListApi.fulfilled, (state, action) => {
            state.loading = false;
            state.result = action?.payload?.result;
            state.message = action?.payload?.message;
        });
        builder.addCase(getBadgesListApi.rejected, (state, action) => {
            state.loading = false;
            state.error = action?.payload?.error;
            state.message = action?.payload?.message;
        });
    },
});
export const { resetgetBadgesList } = getBadgesListSlice.actions;
export const getBadgesListReducer = getBadgesListSlice.reducer;
